import { IComponentController } from 'angular';
import { IStateParamsService } from 'angular-ui-router';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItem } from '../../../../../core/services/menu/menu-item.service';

interface IPageCb2000 extends IComponentController {
    menus: {[key: string]: Array<IMenuItem>},
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    depMultiOccurrence: IMultiOccurrence;
    revMultiOccurrence: IMultiOccurrence;
    actMultiOccurrence: IMultiOccurrence;
    pasMultiOccurrence: IMultiOccurrence;
    avoMultiOccurrence: IMultiOccurrence;
    depMultiOccurrenceOptions: IMultiOccurrenceOptions;
    revMultiOccurrenceOptions: IMultiOccurrenceOptions;
    actMultiOccurrenceOptions: IMultiOccurrenceOptions;
    pasMultiOccurrenceOptions: IMultiOccurrenceOptions;
    avoMultiOccurrenceOptions: IMultiOccurrenceOptions;
    tydMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
    valeursEcran: any;
    estCompteBilan (): boolean;
    estCompteResultat (): boolean;
    estCompteTous (): boolean;
}

/* @ngInject */
export default function Cb2000Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass,
    cb0050Route: IRoute,
    cb2001Route: IRoute,
    cb2002Route: IRoute,
    cb0026Route: IRoute,
    cb0031Route: IRoute,
    cb2005Route: IRoute,
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    $stateParams: IStateParamsService
) {
    const vm: IPageCb2000 = this;

    vm.valeursEcran = ecranDetails.valeurs;
    vm.estCompteBilan = estCompteBilan;
    vm.estCompteResultat = estCompteResultat;
    vm.estCompteTous = estCompteTous;

    function estCompteBilan (): boolean {
        return vm.valeursEcran.vaeprutypcptbdg == "Bilan"
    }

    function estCompteResultat (): boolean {
        return vm.valeursEcran.vaeprutypcptbdg == "Résultat"
    }

    function estCompteTous (): boolean {
        return vm.valeursEcran.vaeprutypcptbdg == "Tous"
    }

    const forageCB0050 = new MenuItemForage(
        'LBL_RESERVE',
        cb0050Route.NAME,
        (rowData: any) => ({
            id: rowData.prucleint,
            prucleint: rowData.prucleint,
            vaesysnatctb: rowData.vaesysnatctb,
            annfindeb: rowData.pecann,
            menuId: $stateParams.menuId
        }),
        {
            fonction: 'RESERVES',
            icon: 'exit_to_app',
            iconButton: true,
            hidden: (rowData: any) => rowData.mntrsv === null
        }
    )

    const criteresSuggeres = new Formulaire([
        new FormulaireItem('prucleint', {default: ($stateParams.id), hidden: true}),
        new FormulaireItem('pecanncri', { disabled: () => ( vm.valeursEcran.vaeprutypbdg === 'P') }),
        new FormulaireItem('indcleintcri')
    ]);

    // Onglet "Depenses"
    vm.depMultiOccurrenceOptions = {
        isTab: true,
        tabSelected: true,
        actionsMore: new Menu([
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2002',
                cb2002Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'DEP',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    indcleint: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.indcleintcri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_DEP_FORAGE_CB2002',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0026',
                cb0026Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'DEP',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_DEP_FORAGE_CB0026',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0031',
                cb0031Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'DEP',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_DEP_FORAGE_CB0031',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2005',
                cb2005Route.NAME,
                (rowData:any) => ({
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'DEP',
                    indcleint: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.indcleintcri,
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_DEP_FORAGE_CB2005',
                    icon: 'exit_to_app'
                }
            )            
        ]),
        fonctions: {
            customCriteresSuggeres: true,
            enregistrerUnEtat: true,
            selectionnerUnEtat: true,
            recherche: false,
            filtrer: false,
            selectionnerDesColonnes: false,
            selectionnerTri: false,
            avisEmploye: false,
            criteresSuggeresVisibles: true,
            effaceCriteres: true
        },
        criteresSuggeres,
        colonnesVisibles: [
            { nom: 'tyhdsc', largeur: 130 },
            { nom: 'ctbmntsum', largeur: 120 },
            { nom: 'ctbmntimp', largeur: 120, total: true },
            { nom: 'mntrsv', largeur: 120, menu: [forageCB0050] }
        ],
        colonnesCachees: [
            'prucleint', 'vaesysnatctb', 'pecann', 'tymcleint'
        ]
    }

    // Onglet "Revenus"
    vm.revMultiOccurrenceOptions = {
        isTab: true,
        tabSelected: true,
        actionsMore: new Menu([
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2002',
                cb2002Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'REV',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    indcleint: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.indcleintcri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_REV_FORAGE_CB2002',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0026',
                cb0026Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'REV',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_REV_FORAGE_CB0026',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0031',
                cb0031Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'REV',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_REV_FORAGE_CB0031',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2005',
                cb2005Route.NAME,
                (rowData:any) => ({
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'REV',
                    indcleint: vm.revMultiOccurrence?.etatSelected?.criteresSuggeresData?.indcleintcri,
                    pecann: vm.revMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_REV_FORAGE_CB2005',
                    icon: 'exit_to_app'
                }
            )            
        ]),
        fonctions: {
            customCriteresSuggeres: true,
                enregistrerUnEtat: false,
                selectionnerUnEtat: false,
                recherche: false,
                filtrer: false,
                selectionnerDesColonnes: false,
                selectionnerTri: false,
                avisEmploye: false,
                criteresSuggeresVisibles: true,
                effaceCriteres: true
        },
        criteresSuggeres,
        colonnesVisibles: [
            { nom: 'tyhdsc', largeur: 130 },
            { nom: 'ctbmntsum', largeur: 120 },
            { nom: 'ctbmntimp', largeur: 120, total: true },
            { nom: 'mntrsv', largeur: 120 }
        ],
        colonnesCachees: [
            'prucleint', 'vaesysnatctb', 'pecann', 'tymcleint'
        ]
    };

    // Onglet "Actifs"
    vm.actMultiOccurrenceOptions = {
        isTab: true,
        tabSelected: true,
        actionsMore: new Menu([
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2002',
                cb2002Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'ACT',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    indcleint: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.indcleintcri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_ACT_FORAGE_CB2002',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0026',
                cb0026Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'ACT',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_ACT_FORAGE_CB0026',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0031',
                cb0031Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'ACT',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_ACT_FORAGE_CB0031',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2005',
                cb2005Route.NAME,
                (rowData:any) => ({
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'ACT',
                    indcleint: vm.actMultiOccurrence?.etatSelected?.criteresSuggeresData?.indcleintcri,
                    pecann: vm.actMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_ACT_FORAGE_CB2005',
                    icon: 'exit_to_app'
                }
            )
        ]),
        fonctions: {
            customCriteresSuggeres: true,
            enregistrerUnEtat: true,
            selectionnerUnEtat: true,
            recherche: false,
            filtrer: false,
            selectionnerDesColonnes: false,
            selectionnerTri: false,
            avisEmploye: false,
            criteresSuggeresVisibles: true,
            effaceCriteres: true
        },
        criteresSuggeres,
        colonnesVisibles: [
            { nom: 'tyhdsc', largeur: 130 },
            { nom: 'ctbmntsum', largeur: 120 },
            { nom: 'ctbmntimp', largeur: 120, total: true },
            { nom: 'mntrsv', largeur: 120 }
        ],
        colonnesCachees: [
            'prucleint', 'vaesysnatctb', 'pecann', 'tymcleint'
        ]
    };

    // Onglet "Passifs"
    vm.pasMultiOccurrenceOptions = {
        isTab: true,
        tabSelected: true,
        actionsMore: new Menu([
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2002',
                cb2002Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'PAS',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    indcleint: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.indcleintcri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_PAS_FORAGE_CB2002',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0026',
                cb0026Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'PAS',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_PAS_FORAGE_CB0026',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0031',
                cb0031Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'PAS',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_PAS_FORAGE_CB0031',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2005',
                cb2005Route.NAME,
                (rowData:any) => ({
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'PAS',
                    indcleint: vm.pasMultiOccurrence?.etatSelected?.criteresSuggeresData?.indcleintcri,
                    pecann: vm.pasMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_PAS_FORAGE_CB2005',
                    icon: 'exit_to_app'
                }
            )
        ]),
        fonctions: {
            customCriteresSuggeres: true,
            enregistrerUnEtat: true,
            selectionnerUnEtat: true,
            recherche: false,
            filtrer: false,
            selectionnerDesColonnes: false,
            selectionnerTri: false,
            avisEmploye: false,
            criteresSuggeresVisibles: true,
            effaceCriteres: true
        },
        criteresSuggeres,
        colonnesVisibles: [
            { nom: 'tyhdsc', largeur: 130 },
            { nom: 'ctbmntsum', largeur: 120 },
            { nom: 'ctbmntimp', largeur: 120, total: true },
            { nom: 'mntrsv', largeur: 120 }
        ],
        colonnesCachees: [
            'prucleint', 'vaesysnatctb', 'pecann', 'tymcleint'
        ]
    };

    // Onglet "Avoirs"
    vm.avoMultiOccurrenceOptions = {
        isTab: true,
        tabSelected: true,
        actionsMore: new Menu([
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2002',
                cb2002Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'AVO',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    indcleint: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.indcleintcri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_AVO_FORAGE_CB2002',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0026',
                cb0026Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'AVO',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_AVO_FORAGE_CB0026',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0031',
                cb0031Route.NAME,
                (rowData:any) => ({
                    id: rowData.prucleint,
                    typapp: 'PRU',
                    typbdg: 'DB',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'AVO',
                    pecann: vm.depMultiOccurrence.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_AVO_FORAGE_CB0031',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB2005',
                cb2005Route.NAME,
                (rowData:any) => ({
                    prucleint: rowData.prucleint,
                    vaesysnatctb: 'AVO',
                    indcleint: vm.avoMultiOccurrence?.etatSelected?.criteresSuggeresData?.indcleintcri,
                    pecann: vm.avoMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecanncri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_AVO_FORAGE_CB2005',
                    icon: 'exit_to_app'
                }
            )
        ]),
        fonctions: {
            customCriteresSuggeres: true,
            enregistrerUnEtat: false,
            selectionnerUnEtat: false,
            recherche: false,
            filtrer: false,
            selectionnerDesColonnes: false,
            selectionnerTri: false,
            avisEmploye: false,
            criteresSuggeresVisibles: true,
            effaceCriteres: true
        },
        criteresSuggeres,
        colonnesVisibles: [
            { nom: 'tyhdsc', largeur: 130 },
            { nom: 'ctbmntsum', largeur: 120 },
            { nom: 'ctbmntimp', largeur: 120, total: true },
            { nom: 'mntrsv', largeur: 120 }
        ],
        colonnesCachees: [
            'prucleint', 'vaesysnatctb', 'pecann', 'tymcleint'
        ]
    };

    vm.tydMultiOccurrenceOptions = {
        bloc: 'tyd',
        actionsRangeeDroite: new Menu([
            new MenuItemForage(
                'LBL_DETAIL',
                cb2001Route.NAME,
                (rowData: any) => ({
                    type: 'PRU',
                    prucleint: rowData.prucleint,
                    vaesysnatctb: rowData.vaesysnatctb,
                    tymcleint: rowData.tymcleint,
                    tydcleint: rowData.tydcleint,
                    pecann: rowData.pecann
                }),
                {
                    icon: 'exit_to_app',
                    fonction: 'BOUDOC',
                    iconButton: true
                }
            )
        ]),
        colonnesVisibles: [
            {nom: 'tyddsc', largeur: 130},
            {nom: 'ctbmntsum', largeur: 120}
        ],
        colonnesCachees: [
            'prucleint',
            'vaesysnatctb',
            'tymcleint',
            'tydcleint',
            'pecann'
        ]
    };

}
